import AdsError from './AdsError.js'

export default class ReportAdError extends AdsError {}
